import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'busStopPerformanceStatictis',
    initialState: {
        isRequesting: false,
        error: null,
        data: {},
        searchCriteria: {},
        dataWithTable: {}
    },
    reducers: {
        get_bus_stop_performance: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload }
            };
        },
        get_bus_stop_performance_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload,
                dataWithTable: action.payload.dataWithTable,
            };
        },
        get_bus_stop_performance_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: {}
            };
        },
        export_bus_stop_performance: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload }
            };
        },
    }
});

export const { reducer, actions } = slice;

export default reducer;